import React, {FC} from 'react';

import {Directory} from 'components/directory';
import {IPageTemplateProps} from 'pages';

interface IDirectoryPageProps extends IPageTemplateProps {
}

export const DirectoryPage: FC<IDirectoryPageProps> = ({
    entityName,
    url,
}: IDirectoryPageProps) => (
    <Directory
        entityName={entityName}
        url={url}
    />
);
